<template>
  <div>
    <div class="page-content">
      <div class="container-fluid">
        <h2 class="content-heading">Token History</h2>
        <div class="main-container">
                    <div class="row">
            <div style="width: 100%;">
              <vue-good-table
                :columns="columns"
                :rows="rows"
                :paginate="true"
                :globalSearch="true"
                :lineNumbers="true"
                styleClass="table table-striped col-md-12"
                >
                  <template slot="table-row" slot-scope="props">
                    <td data-label="User" class="fancy">{{ props.row.user }}</td>
                    <td data-label="Token" class="fancy">{{ props.row.token }}</td>
                    <td data-label="Date" class="fancy">{{ props.row.date }}</td>
                  </template>
              </vue-good-table>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  /* eslint-disable */
  import {mapGetters, mapActions} from 'vuex'

  export default {
    name: 'generate-token',
    data() {
      return {
        responseData: '',
        errors: '',
        componentName: '',
        columns: [
          {
            label: 'User',
            field: 'user',
            filterable: true,
          },
          {
            label: 'Token',
            field: 'token',
            filterable: true,
          },
          {
            label: 'Date',
            field: 'date',
            filterable: true,
          }
        ],
      rows: [
        {user:"", token: '', date: ''},
      ],
      };
    },
    methods: {
      random_num: (dumm) => {
        return Math.floor(Math.random(9999) * 9999);
      },
      showModal () {
      this.$refs.myModalRef.show()
    },
    hideModal () {
      this.$refs.myModalRef.hide()
    }
    },
    computed: {
    },
    mounted() {
    },
  };

</script>
<style>
.widget_box{
  min-height: auto !important;
}
.modal-header{
  border-bottom-left-radius: 50% 20%;
  border-bottom-right-radius: 50% 20%;
  background: #ecf2f6;
  /* height: 100px; */
}
</style>




// WEBPACK FOOTER //
// src/components/pages/shs/TokenHistory.vue